import React from 'react';
import { CloseIcon } from '@yme/assets/index';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey } from '@yme/common/index';
import { getIconType } from './helpers';
import { AlertActions, AlertMessageWrapper, AlertStyled, AlertMessageText, AlertMessageExtra, AlertMessageExtraContent, } from './styled';
import { AlertType } from './types';
export function Alert({ action, alignCenter, flexAlign, type = AlertType.MESSAGE, message, isIconShowed = true, isRightToLeft, customIcon, onClose, isFullWidth, hideExtraContent, className, children, dataTestId = '', }) {
    const alertDataTestId = buildKey(dataTestId, 'alert-block');
    return (React.createElement(AlertStyled, { className: className, flexAlign: flexAlign, alignCenter: alignCenter, type: type, isRightToLeft: isRightToLeft, isFullWidth: isFullWidth, "data-testid": alertDataTestId, role: "alert" },
        React.createElement(AlertMessageWrapper, { alignCenter: alignCenter, isFullWidth: hideExtraContent },
            isIconShowed && (React.createElement(SVGIcon, { type: customIcon || getIconType(type), size: ICON_SIZE.xs })),
            React.createElement(AlertMessageText, null, message)),
        !hideExtraContent && (React.createElement(AlertMessageExtra, null,
            React.createElement(AlertMessageExtraContent, null,
                (action || onClose) && (React.createElement(AlertActions, { isRightToLeft: isRightToLeft },
                    action,
                    onClose && (React.createElement(SVGIcon, { type: CloseIcon, onClick: onClose })))),
                children && children)))));
}
